module.exports = {
        API_URL: 'https://vetopedia.org/api/',
	NOCO_DB_MOBILFUNK_TABLE_ID: 'mbua09lpjrwbmts'
}

